export default __webpack_public_path__ + "static/media/689.2f6f63e8.png";